var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "app-container view-container",
      attrs: {
        "label-position": "top",
        model: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
      },
    },
    [
      _c(
        "BjDivider",
        [
          _vm._v(
            " " + _vm._s(_vm.$t("CustomerFunction.common.warehouseAdd")) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.tryCancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      [
        _c(
          "el-row",
          { attrs: { gutter: 10 } },
          [
            !this.$store.getters.cusId
              ? _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("billingPage.CustomerName") } },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.clientCodeList,
                            disabled: true,
                          },
                          model: {
                            value: _vm.form.clientCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "clientCode", $$v)
                            },
                            expression: "form.clientCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("CustomerFunction.common.logisticsNo"),
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("inputText"),
                        disabled: true,
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.logisticsNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "logisticsNumber", $$v)
                        },
                        expression: "form.logisticsNumber",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("CustomerFunction.common.associatedCode"),
                      prop: "",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("chooseText"),
                        disabled: true,
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.associatedCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "associatedCode", $$v)
                        },
                        expression: "form.associatedCode",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      _c(
        "div",
        { staticClass: "bj-row mt20" },
        [
          _c(
            "BjDivider",
            [
              _vm._v(
                _vm._s(_vm.$t("AddingAnInternalReturnRefundDoc.Product")) + " "
              ),
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleShowFnForDialogSkuList },
                  },
                  [_vm._v(_vm._s(_vm.$t("BusinessAfterCsgReturn.table.add")))]
                ),
              ],
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "bj-col bj-col-24",
              staticStyle: { "border-left": "none" },
            },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.form.confirmSkuList,
                    border: "",
                    script: "",
                    "max-height": "600px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("table.countText"),
                      type: "index",
                      width: "55",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "sku", label: "SKU", align: "center" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "barCode",
                      label: _vm.$t("BusinessPurchaseDetailPage.table.Barcode"),
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "returnTotal",
                      label: _vm.$t("UploadTotalText"),
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("span", { staticClass: "red" }, [_vm._v("*")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("CustomerFunction.common.Quantityof")
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("BjInputNumber", {
                              staticClass: "full-width",
                              attrs: { clearable: "", controls: false },
                              model: {
                                value: row.nonDefectiveNumber,
                                callback: function ($$v) {
                                  _vm.$set(row, "nonDefectiveNumber", $$v)
                                },
                                expression: "row.nonDefectiveNumber",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "nonDefectiveHandling",
                      label: _vm.$t("CustomerFunction.table.GoodQuality"),
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.CSG_RETURN_LIST_ADMIN_STATUS.bjGet(
                                      row.nonDefectiveHandling
                                    )
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("span", { staticClass: "red" }, [_vm._v("*")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "CustomerFunction.common.Quantityofdefective"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("BjInputNumber", {
                              staticClass: "full-width",
                              attrs: { clearable: "", controls: false },
                              model: {
                                value: row.defectiveNumber,
                                callback: function ($$v) {
                                  _vm.$set(row, "defectiveNumber", $$v)
                                },
                                expression: "row.defectiveNumber",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "defectiveHandling",
                      label: _vm.$t("CustomerFunction.table.HandlingOf"),
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.CSG_RETURN_LIST_ADMIN_STATUS.bjGet(
                                      row.defectiveHandling
                                    )
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("table.operationText"),
                      fixed: "right",
                      align: "center",
                      width: "110",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var $index = ref.$index
                          return [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.onDelete($index)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("delText")))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("AddingAnInternalReturnRefundDoc.Picture"))),
      ]),
      _c(
        "div",
        { staticClass: "mt20" },
        [
          _c(
            "el-form-item",
            { staticStyle: { display: "block", height: "100%" } },
            [
              _c(
                "BjUpload",
                {
                  ref: "BjUpload",
                  staticClass: "avatar-uploader",
                  attrs: {
                    limit: 3,
                    "limit-size": 5 * 1024,
                    multiple: "",
                    "show-file-list": "",
                    "list-type": "picture-card",
                    accept: "image/png,image/jpeg",
                    "accept-list": ["image/jpeg", "image/png"],
                    "auto-upload": "",
                    "limit-hide": "",
                  },
                  on: { afterUpload: _vm.afterUpload, remove: _vm.onRemoveUrl },
                },
                [
                  _c("template", { slot: "default" }, [
                    _c("i", {
                      staticClass: "el-icon-plus avatar-uploader-icon",
                    }),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "dialogList",
        attrs: {
          colSpan: 8,
          config: _vm.$BjDialogListConfig.skuDefault("SelectSKUText", {
            defaultQuery: _vm.defaultQuery,
            columns: _vm.columns,
            search: _vm.search,
            actionApi: _vm.actionApi,
          }),
          multiple: "",
        },
        on: { confirm: _vm.onAddDialogConfirm },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }